import React from "react";
import classes from "./style/UI_ModuleTextDownCard.module.css";
import { nanoid } from "@reduxjs/toolkit";

export enum TextTheme {
  PRIMARY = "primary",
  ERROR = "error",
}

interface UI_ModuleTextDownCard {
  textDown: string[];
  theme?: TextTheme;
}

// нижний текст карточки
export const UI_ModuleTextDownCard: React.FC<UI_ModuleTextDownCard> = (
  props
) => {
  const { textDown, theme = TextTheme.PRIMARY } = props;
  return (
    <div className={classes.cardTextDownWrapper}>
      {textDown?.map((item) => {
        const id = nanoid();
        return (
          <div className={`${classes.cardTextDown} ${classes[theme]}`} key={id}>
            {item}
          </div>
        );
      })}
    </div>
  );
};
